// ORDER_DIRECTIONS / OrderDirection удалены 2026-06-12 (волна 2 PR6): словарь
// направлений legacy-таблицы Order описывал архивные модули (Ozon/WB — ветка
// archive/ozonwb-flow; packing/from_rf/to_rf/receipt/pickup — закрыты раньше).
// Wire-поле `direction` легаси-строк теперь типизировано как string
// (см. types/index.ts) — живые направления (flex, shop) имеют свои таблицы.
export const ORDER_STATUSES = [
    "draft",
    "approved",
    "has_qr",
    "picked_up",
    "in_transit",
    "at_warehouse",
    "ready",
    "delivered",
    // Flex pre-order: recipient identity incomplete; client uses this string to
    // surface the "Заполнить →" CTA on OrdersScreen. Serializer maps from
    // FlexOrder { status: "draft", preorder: true } → this status for clients.
    "pending_recipient_data",
];
/**
 * Именованные константы статусов — чтобы в коде не было magic-строк
 * `"ready"` / `"delivered"`. Тип каждого поля — узкий литерал, поэтому
 * случайные опечатки ловятся компилятором.
 */
export const ORDER_STATUS = {
    DRAFT: "draft",
    APPROVED: "approved",
    HAS_QR: "has_qr",
    PICKED_UP: "picked_up",
    IN_TRANSIT: "in_transit",
    AT_WAREHOUSE: "at_warehouse",
    READY: "ready",
    DELIVERED: "delivered",
};
// STATUS_FLOW (линейный граф статусов legacy-таблицы Order) удалён 2026-06-12
// (волна 2 PR6): последний потребитель — реестр DIRECTIONS — ушёл вместе с ним.
export const ITEM_CATEGORIES = [
    // RED (PRD §4.1)
    "medicine",
    "seeds",
    "bads",
    "dual_use",
    "info_storage",
    "powders",
    // YELLOW (PRD §4.1)
    "electronics",
    "cosmetics",
    "food",
    "alcohol",
    "jewelry",
    "household_chemicals",
    "tea_coffee",
    "parts",
    "appliances",
    // GREEN (PRD §4.1)
    "clothes",
    "shoes",
    "books",
    "toys",
    "accessories",
    "other",
];
export const HIGH_TARIFF_CATEGORIES = [
    "electronics",
    "cosmetics",
    "food",
];
export const RESTRICTED_CATEGORIES = ["medicine", "seeds"];
export const PRICING = {
    BASE_KG: 2,
    BASE_GEL: 30,
    PER_EXTRA_KG_GEL: 15,
    HIGH_TARIFF_MULTIPLIER: 1.5,
    CARRIER_THRESHOLD_GEL: 300,
};
/**
 * Fallback-веса по категориям (кг за единицу), если Perplexity в workflow
 * не нашёл точный вес (т.е. `weightKg === null`). Подобраны «на глаз»
 * под типовые Ozon/WB позиции — правим по мере накопления статистики.
 */
export const DEFAULT_WEIGHT_KG_BY_CATEGORY = {
    // RED
    medicine: 0.1,
    seeds: 0.1,
    bads: 0.15,
    dual_use: 0.5,
    info_storage: 0.1,
    powders: 0.3,
    // YELLOW
    electronics: 0.5,
    cosmetics: 0.2,
    food: 0.5,
    alcohol: 1.0,
    jewelry: 0.05,
    household_chemicals: 0.5,
    tea_coffee: 0.3,
    parts: 0.5,
    appliances: 2.0,
    // GREEN
    clothes: 0.3,
    shoes: 0.7,
    books: 0.5,
    toys: 0.4,
    accessories: 0.2,
    other: 0.5,
};
/**
 * Дружественные русские названия категорий для уведомлений владельцу.
 */
export const CATEGORY_NAMES_RU = {
    // RED
    medicine: "Лекарства",
    seeds: "Семена",
    bads: "БАДы",
    dual_use: "Двойное назначение",
    info_storage: "Носители информации",
    powders: "Порошки",
    // YELLOW
    electronics: "Электроника",
    cosmetics: "Косметика",
    food: "Продукты",
    alcohol: "Алкоголь",
    jewelry: "Ювелирные изделия",
    household_chemicals: "Бытовая химия",
    tea_coffee: "Чай и кофе",
    parts: "Запчасти",
    appliances: "Бытовая техника",
    // GREEN
    clothes: "Одежда",
    shoes: "Обувь",
    books: "Книги",
    toys: "Игрушки",
    accessories: "Аксессуары",
    other: "Прочее",
};
// Способ доставки legacy-строк Order (wire-тип Order.deliveryType в types/).
export const DELIVERY_TYPES = ["truck", "carrier"];
//# sourceMappingURL=index.js.map